import {
	BUTTON,
	CHECKBOX,
	INDIVIDUAL,
	INPUT,
	LINK,
	PROFESSIONAL,
	IS_ELEC,
	IS_EG,
	IS_GAS,
	MONO_COUNTER, BI_COUNTER, ANNUM_CONSUMPTION, ANNUM_INJECTION, POSTCODE_QUESTION
} from "../../../utils/constants";
import {
	inputNotBlank, numberValidation,
	panelsPowerValidation,
	surveyPostCodeValidation
} from "../../../utils/validators";
import PostCodeQuestion from "./PostCodeQuestion";

export const questionsList = [
	{
		questionId: "Q1",
		text: "survey.questions.Q1",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN2",
				label: "survey.answers.AN2",
				value: INDIVIDUAL,
				icon: "",
				type: ""
			},
			{
				id: "AN1",
				label: "survey.answers.AN1",
				value: PROFESSIONAL,
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q2",
		text: "survey.questions.Q2",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN3",
				label: "survey.answers.AN3",
				value: IS_ELEC,
				icon: "",
				type: ""
			},
			{
				id: "AN5",
				label: "survey.answers.AN5",
				value: IS_EG,
				icon: "",
				type: ""
			},
			{
				id: "AN4",
				label: "survey.answers.AN4",
				value: IS_GAS,
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q3",
		text: "survey.questions.Q3",
		note: "",
		isAuto: false,
		validate: surveyPostCodeValidation,
		[POSTCODE_QUESTION]: [{
			id: "AN6",
			label: "",
			value: "",
			icon: "",
			type: ""
		}]
		// [INPUT]: [{
		// 	id: "AN6",
		// 	label: "",
		// 	value: "",
		// 	icon: ""
		// }],
		// [CHECKBOX]: [{
		// 	id: "AN46",
		// 	label: "survey.answers.AN46",
		// 	value: true,
		// 	icon: ""
		// }]
	},
	{
		questionId: "Q4",
		text: "survey.questions.Q4",
		note: "survey.questions_sub_labels.Q4",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN7",
				label: "survey.answers.AN7",
				value: "true",
				icon: "",
				type: ""
			}, {
				id: "AN8",
				label: "survey.answers.AN8",
				value: "false",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q7",
		text: "survey.questions.Q7",
		note: "survey.questions_sub_labels.Q7",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN12",
				label: "survey.answers.AN12",
				value: "true",
				icon: "",
				type: ""
			},
				{
				id: "AN13",
				label: "survey.answers.AN13",
				value: "false",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q5",
		text: "survey.questions.Q5",
		note: "",
		isAuto: false,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN9",
				label: "survey.answers.AN9",
				value: MONO_COUNTER,
				icon: "/img/monohoraire.png",
				type: ""
			},
			{
				id: "AN10",
				label: "survey.answers.AN10",
				value: BI_COUNTER,
				icon: "/img/bihoraire.png",
				type: ""
			}
		],
		[CHECKBOX]: [{
			id: "AN11",
			label: "survey.answers.AN11",
			value: false,
			icon: "",
			type: ""
		}]
	},
	{
		questionId: "Q8",
		text: "survey.questions.Q8",
		note: "",
		isAuto: false,
		validate: panelsPowerValidation,
		[INPUT]: [{
			id: "AN14",
			label: "survey.answers.AN14",
			value: "",
			icon: "",
			unit: "kVA",
			type: "number"
		}],
		[LINK]: [{
			id: "AN14",
			label: "survey.answers.AN15",
			value: "4.5",
			icon: "",
			type: ""
		}]
	},
	{
		questionId: "Q9",
		text: "survey.questions.Q9",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN16",
				label: "survey.answers.AN16",
				value: "true",
				icon: "",
				type: ""
			},
			{
				id: "AN17",
				label: "survey.answers.AN17",
				value: "false",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q10",
		text: "survey.questions.Q10",
		note: "",
		isAuto: false,
		validate: inputNotBlank,
		[ANNUM_CONSUMPTION]: [
			{
				id: "AN19",
				label: "survey.answers.AN19",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN38",
				label: "survey.answers.AN38",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN39",
				label: "survey.answers.AN39",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN40",
				label: "survey.answers.AN40",
				value: "",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q13",
		text: "survey.questions.Q13",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN22",
				label: "survey.answers.AN22",
				value: "1",
				icon: "",
				type: ""
			}, {
				id: "AN21",
				label: "survey.answers.AN21",
				value: "2",
				icon: "",
				type: ""
			}, {
				id: "AN23",
				label: "survey.answers.AN23",
				value: "3",
				icon: "",
				type: ""
			}, {
				id: "AN24",
				label: "survey.answers.AN24",
				value: "4",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q14",
		text: "survey.questions.Q14",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN25",
				label: "survey.answers.AN25",
				value: "1",
				icon: "",
				type: ""
			}, {
				id: "AN26",
				label: "survey.answers.AN26",
				value: "2",
				icon: "",
				type: ""
			}, {
				id: "AN27",
				label: "survey.answers.AN27",
				value: "3",
				icon: "",
				type: ""
			}, {
				id: "AN28",
				label: "survey.answers.AN28",
				value: "4",
				icon: "",
				type: ""
			}, {
				id: "AN29",
				label: "survey.answers.AN29",
				value: "5",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q15",
		text: "survey.questions.Q15",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN30",
				label: "survey.answers.AN30",
				value: "2",
				icon: "",
				type: ""
			}, {
				id: "AN31",
				label: "survey.answers.AN31",
				value: "1",
				icon: "",
				type: ""
			}, {
				id: "AN32",
				label: "survey.answers.AN32",
				value: "3",
				icon: "",
				type: ""
			}, {
				id: "AN33",
				label: "survey.answers.AN33",
				value: "4",
				icon: "",
				type: ""
			}, {
				id: "AN34",
				label: "survey.answers.AN34",
				value: "5",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q17",
		text: "survey.questions.Q17",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN35",
				label: "survey.answers.AN35",
				value: "1",
				icon: "/img/type.png",
				type: ""
			}, {
				id: "AN36",
				label: "survey.answers.AN36",
				value: "2",
				icon: "/img/pme.png",
				type: ""
			}, {
				id: "AN37",
				label: "survey.answers.AN37",
				value: "3",
				icon: "/img/enterprise.png",
				type: ""
			}
		]
	},
	{
		questionId: "Q18",
		text: "survey.questions.Q18",
		note: "",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN30",
				label: "survey.answers.AN30",
				value: "2",
				icon: "",
				type: ""
			}, {
				id: "AN31",
				label: "survey.answers.AN31",
				value: "1",
				icon: "",
				type: ""
			}, {
				id: "AN32",
				label: "survey.answers.AN32",
				value: "3",
				icon: "",
				type: ""
			}, {
				id: "AN33",
				label: "survey.answers.AN33",
				value: "4",
				icon: "",
				type: ""
			}, {
				id: "AN34",
				label: "survey.answers.AN34",
				value: "5",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q12",
		text: "survey.questions.Q12",
		note: "survey.questions_sub_labels.Q12",
		isAuto: false,
		validate: numberValidation,
		[ANNUM_INJECTION]: [
			{
				id: "AN42",
				label: "survey.answers.AN42",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN43",
				label: "survey.answers.AN43",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN44",
				label: "survey.answers.AN44",
				value: "",
				icon: "",
				type: ""
			}, {
				id: "AN45",
				label: "survey.answers.AN45",
				value: "",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q19",
		text: "survey.questions.Q19",
		note: "",
		isAuto: false,
		validate: numberValidation,
		[INPUT]: [{
			id: "AN47",
			label: "survey.answers.AN47",
			value: "",
			icon: "",
			unit: "kW",
			type: "number"
		}],
		[LINK]: [{
			id: "AN47",// AN48
			label: "survey.answers.AN48",
			value: "2.5",
			icon: "",
			type: ""
		}]
	},
	{
		questionId: "Q20",
		text: "survey.questions.Q20",
		note: "survey.questions_sub_labels.Q20",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN49",
				label: "survey.answers.AN49",
				value: "true",
				icon: "",
				type: ""
			}, {
				id: "AN50",
				label: "survey.answers.AN50",
				value: "false",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q21",
		text: "survey.questions.Q21",
		note: "survey.questions_sub_labels.Q21",
		isAuto: true,
		validate: inputNotBlank,
		[BUTTON]: [
			{
				id: "AN51",
				label: "survey.answers.AN51",
				value: "true",
				icon: "",
				type: ""
			}, {
				id: "AN52",
				label: "survey.answers.AN52",
				value: "false",
				icon: "",
				type: ""
			}
		]
	},
	{
		questionId: "Q22",
		text: "survey.questions.Q22",
		note: "",
		isAuto: true,
		validate: () => {},
		[LINK]: [{
			id: "AN53",
			label: "survey.answers.AN53",
			value: "",
			icon: "",
			type: ""
		}]
	}
]
